import React from 'react'
import ReactDOM from 'react-dom'
import cloneDeep from 'lodash.clonedeep'
import mitt from 'mitt'
import { Button } from './components'
import { PopupConfig } from './components/PopupConfig'
import { PopupProvider } from './context/popupContext'
import { ELEMENT_ID } from './shared/constants'

const emitter = mitt()

export const PopupContainer = (self, target) => {
  const { button } = self.options.locale.modalPopup
  const contentPopup = cloneDeep(self.options.contentPopup)
  const modalPopup = cloneDeep(self.options.locale.modalPopup)
  const initialState = { contentPopup, modalPopup, defaultsRef: self.options }
  const { contentScripts } = self.options

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <Button label={button} emitter={emitter} />,
    document.getElementById(target)
  )

  self.wrapper.append(`<div id="${ELEMENT_ID}"></div>`)
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <>
      <PopupProvider initialState={initialState}>
        <PopupConfig
          content={self.options.contentPopup}
          emitter={emitter}
          contentScripts={contentScripts}
        />
      </PopupProvider>
    </>,
    document.getElementById(ELEMENT_ID)
  )
}
